export const range = (end, start = 0) => Array(end - start)
    .fill(undefined)
    .map((_, i) => start + i);
export const to = (fn) => 
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
(sum, _item, index, all) => {
    const isLast = index === all.length - 1;
    if (!isLast) {
        return sum;
    }
    return fn(all);
};
export const constant = (value) => () => value;
export const identity = (x) => x;
export const toIndexedObject = (fn) => (sum, item, index) => {
    const [key, value] = fn(item, index);
    return (sum[key] = value), sum;
};
export const mapToIndexedObject = (fn, items, initial = {}) => items.reduce(toIndexedObject(fn), initial);
export const pairsToIndexedObject = (sum, [key, value]) => ((sum[key] = value), sum);
Array.prototype.chain_ = function (fn) {
    return fn(this);
};
export const successfulValidation = (value) => ({
    success: true,
    value,
});
export const failedValidation = (error) => ({
    success: false,
    error,
});
export const take = (count, arr) => !isFinite(count) ? [...arr] : arr.slice(0, count);
export const drop = (count, arr) => !isFinite(count) ? [] : arr.splice(count);
